var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCanvasLms(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    className: "svg-canvas-logo",
    x: "0px",
    y: "0px",
    enableBackground: "new 0 0 115 27",
    xmlSpace: "preserve",
    viewBox: "0 0.1 26.7 26.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "svg-logo-canvas__logomark"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    fill: "#D64027",
    d: "M3.9,13.5c0-2-1.5-3.6-3.4-3.8C0.2,10.9,0,12.1,0,13.5s0.2,2.6,0.5,3.8C2.4,17.1,3.9,15.4,3.9,13.5L3.9,13.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#D64027",
    cx: 6.2,
    cy: 13.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_1_",
    fill: "#D64027",
    d: "M22.8,13.5c0,2,1.5,3.6,3.4,3.8c0.3-1.2,0.5-2.5,0.5-3.8s-0.2-2.6-0.5-3.8C24.3,9.9,22.8,11.5,22.8,13.5L22.8,13.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval_1_",
    fill: "#D64027",
    cx: 20.2,
    cy: 13.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_2_",
    fill: "#D64027",
    d: "M13.3,23c-2,0-3.6,1.5-3.8,3.4c1.2,0.3,2.5,0.5,3.8,0.5c1.3,0,2.6-0.2,3.8-0.5C16.9,24.5,15.3,23,13.3,23L13.3,23z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval_2_",
    fill: "#D64027",
    cx: 13.2,
    cy: 20.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_3_",
    fill: "#D64027",
    d: "M13.3,4c2,0,3.6-1.5,3.8-3.4c-1.2-0.3-2.5-0.5-3.8-0.5c-1.3,0-2.6,0.2-3.8,0.5C9.7,2.5,11.3,4,13.3,4L13.3,4z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval_3_",
    fill: "#D64027",
    cx: 13.2,
    cy: 6.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_4_",
    fill: "#D64027",
    d: "M20,20.2c-1.4,1.4-1.5,3.6-0.3,5.1c2.2-1.3,4.1-3.2,5.4-5.4C23.6,18.7,21.4,18.8,20,20.2L20,20.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval_4_",
    fill: "#D64027",
    cx: 18.2,
    cy: 18.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_5_",
    fill: "#D64027",
    d: "M6.6,6.8C8,5.4,8.1,3.2,6.9,1.7C4.7,3,2.8,4.9,1.5,7.1C3,8.3,5.2,8.2,6.6,6.8L6.6,6.8z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval_5_",
    fill: "#D64027",
    cx: 8.2,
    cy: 8.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_6_",
    fill: "#D64027",
    d: "M20,6.8c1.4,1.4,3.6,1.5,5.1,0.3c-1.3-2.2-3.2-4.1-5.4-5.4C18.5,3.2,18.6,5.4,20,6.8L20,6.8z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval_6_",
    fill: "#D64027",
    cx: 18.2,
    cy: 8.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_7_",
    fill: "#D64027",
    d: "M6.6,20.2c-1.4-1.4-3.6-1.5-5.1-0.3c1.3,2.2,3.2,4.1,5.4,5.4C8.1,23.7,8,21.6,6.6,20.2L6.6,20.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval_7_",
    fill: "#D64027",
    cx: 8.2,
    cy: 18.4,
    r: 1.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCanvasLms);
export default __webpack_public_path__ + "static/media/canvas-lms.e3a999a271f01fa5ffc46df9fe77c543.svg";
export { ForwardRef as ReactComponent };